import script from "./PlaylistOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistOptions.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistOptions.vue?vue&type=style&index=0&id=38ba1144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ba1144"]])

export default __exports__